import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { ItemsComponent } from './items.component';
import { FillItemComponent } from './fill-item/fill-item.component';
import { QuillConfigModule, QuillModule } from 'ngx-quill';
import { EvaluateItemsComponent } from './evaluate-items/evaluate-items.component';
import { MaterialModule } from 'src/app/modules/shared-modules/material.module';
import { defaultQuilConfig } from 'src/app/utils/quill-config.util';
import { SharedModule } from '../../shared-modules/shared.module';
import {MatButtonToggleModule} from '@angular/material/button-toggle';

@NgModule({
    exports: [
        EvaluateItemsComponent
    ],
    imports: [
        MatButtonToggleModule,
        CommonModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        QuillModule.forRoot(),
        QuillConfigModule.forRoot(defaultQuilConfig),
        ItemsComponent,
        FillItemComponent,
        EvaluateItemsComponent
    ]
})
export class ItemsDataModule { }
